export const kitchenDocketTemplate = `
<?xml version="1.0" encoding="UTF-8"?>
<document>
  <print-mode mode="{{printMode}}" />
  {{#title}}
  <align mode="center">
    <text-line size="0:1">{{title}}</text-line>
  </align>
  {{/title}}
  {{#printerProfile}}
  <align mode="center">
    <text-line size="1:1">{{printerProfile}}</text-line>
  </align>
  {{/printerProfile}}
  {{#timeStamp}}
  <align mode="center">
    <text-line size="0:0">{{timeStamp}}</text-line>
  </align>
  {{/timeStamp}}
  {{#divider}}
  <align mode="center">
    <text-line size="0:0">{{{divider}}}</text-line>
    <line-feed />
  </align>
  {{/divider}}
  {{#channel}}
  <align mode="center">
    <text-line size="0:1">{{channel}}</text-line>
    <text-line size="0:0">{{{divider}}}</text-line>
    <line-feed />
  </align>
  {{/channel}}
  <align mode="center">
    <bold>
      <text-line size="1:1">{{orderType}}</text-line>
    </bold>
  </align>
  {{#orderName}}
  <align mode="center">
    <text-line size="0:0">{{{divider}}}</text-line>
    <text-line size="1:1">{{orderName}}</text-line>
    <text-line size="0:0">{{{divider}}}</text-line>
  </align>
  {{/orderName}}
  <line-feed />
  <align mode="center">
    <bold>
      <text-line size="0:0">{{orderDetails}}</text-line>
    </bold>
  </align>
  {{#reasonOrNote}}
  <align mode="center">
    <bold>
      <text-line size="0:1">{{reasonOrNote}}</text-line>
      <text-line>{{{divider}}}</text-line>
    </bold>
  </align>
  {{/reasonOrNote}}
  {{#allergens}}
  <bold>
    <text-line>{{{divider}}}</text-line>
    <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{allergens}}</text-line>
  </bold>
  <line-feed />
  {{/allergens}}
  {{#orderItems}}
  <align mode="center">
    {{#header}}
    <bold>
      <text-line size="0:1" {{#printHeaderInRed}}color="red"{{/printHeaderInRed}}>{{header}}</text-line>
    </bold>
    {{#showHeaderDivider}}
        <text-line size="0:0">{{dashDivider}}</text-line>
    {{/showHeaderDivider}}
    {{/header}}
    {{#groupedItems}}
    {{#subHeader}}
    <line-feed />
    {{#showSubDivider}}
      <text-line size="0:0">{{dashDivider}}</text-line>
    {{/showSubDivider}}
    <bold>
      <text-line size="0:1" {{#printSubHeaderInRed}}color="red"{{/printSubHeaderInRed}}>{{subHeader}}</text-line>
    </bold>
    {{/subHeader}}
    {{#seatAllergens}}
      <line-feed />
      <bold>
        <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{seatAllergens}}</text-line>
      </bold>
    {{/seatAllergens}}
    {{#items}}
    <line-feed />
    <align mode="left">
      <bold>
        <text-line size="1:1">{{product}}</text-line>
      </bold>
    </align>
    {{#itemAllergens}}
    <align mode="left">
      <bold>
        <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line>
      </bold>
    </align>
    {{/itemAllergens}}
    <align mode="center">
    {{#note}}
      <bold>
        <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="1:0">{{note}}</text-line>
      </bold>
    {{/note}}
    {{#comboItems}}
      <bold><text-line size="0:1">{{product}}</text-line></bold>
      {{#itemAllergens}}
        <bold><text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line></bold>
      {{/itemAllergens}}
      {{#note}}
        <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="0:1">{{note}}</text-line>
      {{/note}}
      {{#modifiers}}
        <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:0">{{text}}</text-line>
      {{/modifiers}}
    {{/comboItems}}
    {{#modifiers}}
      <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:1" >{{text}}</text-line>
    {{/modifiers}}
    {{/items}}
    {{/groupedItems}}
    {{#showHeaderDivider}}
        <text-line size="0:0">{{dashDivider}}</text-line>
    {{/showHeaderDivider}}
    </align>
    </align>
  {{/orderItems}}
  {{#notifiersHeader}}
      <align mode= "center">
        <bold>
          <text-line size="1:0">{{notifiersHeader}}</text-line>
        </bold>
        <line-feed />
        <text-line size="0:0">{{dashDivider}}</text-line>
      </align>
    {{/notifiersHeader}}
    {{#notifierOrderItems}}
    {{#header}}
    <align mode="center">
    <bold>
      <text-line size="1:0" color="red">{{header}}</text-line>
    </bold>
    <line-feed />
    </align>
    {{/header}}
      {{#groupedItems}}
        {{#items}}
            <align mode= "center">
              <bold>
                <text-line size="1:0">{{product}}</text-line>
              </bold>
              {{#modifiers}}
              <bold>
              <text-line size="0:0">{{text}}</text-line>
              </bold>
              {{/modifiers}}
            </align>
        {{/items}}
      {{/groupedItems}}
  {{/notifierOrderItems}}
  <align mode="center">
    {{#customerName}}
    <text-line size="0:1">{{customerName}}</text-line>
    {{/customerName}}
    {{#customerPhone}}
    <text-line size="0:1">{{customerPhone}}</text-line>
    {{/customerPhone}}
    {{#customerAddress}}
    <text-line size="0:1">{{customerAddress}}</text-line>
    {{/customerAddress}}
  </align>
  <paper-cut />
  {{#kitchenBuzzer}}
  <open-cash-drawer></open-cash-drawer>
  {{/kitchenBuzzer}}
</document>
`;

export const smlkitchenDocketTemplate = `
<?xml version= "1.0" encoding= "UTF-8"?>
<document>
  <print-mode mode= {{printMode}} />
  <align mode= "center">
    <text-line size= "0:0">{{title}}</text-line>
    {{#printerProfile}}
    <text-line size= "1:0">{{printerProfile}}</text-line>
    {{/printerProfile}}
    <text-line size= "0:0">{{timeStamp}}</text-line>
  </align>
  <align mode= "center">
    <text-line size= "0:0">{{{divider}}}</text-line>
    <line-feed />
  </align>
  {{#channel}}
    <align mode= "center">
      <text-line size= "0:0">{{channel}}</text-line>
      <text-line size= "0:0">{{{divider}}}</text-line>
      <line-feed />
    </align>
  {{/channel}}
  <align mode= "center">
    <bold>
      <text-line size= "1:0">{{orderType}}</text-line>
    </bold>
  </align>
  {{#orderName}}
    <align mode= "center">
      <text-line size= "0:0">{{{divider}}}</text-line>
      <text-line size= "1:0">{{orderName}}</text-line>
      <text-line size= "0:0">{{{divider}}}</text-line>
    </align>
  {{/orderName}}
  <line-feed />
  <align mode= "center">
    <bold>
      <text-line size= "0:0">{{orderDetails}}</text-line>
    </bold>
  </align>
  <align mode= "center">
    <text-line>{{{divider}}}</text-line>
  </align>
  <align mode= "center">
    <line-feed />
    {{#reasonOrNote}}
      <bold>
        <text-line size= "0:0">{{reasonOrNote}}</text-line>
      </bold>
    <line-feed />
    {{/reasonOrNote}}
    {{#allergens}}
    <bold>
      <text-line>{{{divider}}}</text-line>
      <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{allergens}}</text-line>
    </bold>
    <line-feed />
    {{/allergens}}
    <text-line>{{{divider}}}</text-line>
  </align>
  {{#orderItems}}
    {{#header}}
      <align mode= "center">
        <bold>
          <text-line size="0:0" {{#printHeaderInRed}}color="red"{{/printHeaderInRed}}>{{header}}</text-line>
        </bold>
      {{#showHeaderDivider}}
          <text-line size="0:0">{{dashDivider}}</text-line>
      {{/showHeaderDivider}}
      </align>
    {{/header}}
      {{#groupedItems}}
      <line-feed />
        {{#subHeader}}
          <align mode= "center">
            <bold>
             <text-line size="0:0" {{#printSubHeaderInRed}}color="red"{{/printSubHeaderInRed}}>{{subHeader}}</text-line>
            </bold>
          </align>
        {{/subHeader}}
        {{#seatAllergens}}
          <line-feed />
          <bold>
            <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{seatAllergens}}</text-line>
          </bold>
        {{/seatAllergens}}
        {{#items}}
          <line-feed />
          <align mode="left">
            <bold>
              <text-line size= "1:0">{{product}}</text-line>
            </bold>
          </align>
          {{#itemAllergens}}
          <align mode="left">
            <bold>
              <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:0">{{itemAllergens}}</text-line>
            </bold>
          </align>
          {{/itemAllergens}}
          <align mode="center">
            {{#note}}
              <bold>
                <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="1:0">{{note}}</text-line>
              </bold>
            {{/note}}
            {{#comboItems}}
              <bold><text-line size="0:0">{{product}}</text-line></bold>
              {{#itemAllergens}}
                <bold><text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:0">{{itemAllergens}}</text-line></bold>
              {{/itemAllergens}}
              {{#note}}
                <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="0:0">{{note}}</text-line>
              {{/note}}
              {{#modifiers}}
                <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:0">{{text}}</text-line>
              {{/modifiers}}
            {{/comboItems}}
            {{#modifiers}}
              <text-line {{#printInRed}} color="red" {{/printInRed}} >{{text}}</text-line>
          {{/modifiers}}
        {{/items}}
      {{/groupedItems}}
      {{#showHeaderDivider}}
        <text-line size="0:0">{{dashDivider}}</text-line>
      {{/showHeaderDivider}}
      </align>
  {{/orderItems}}
  {{#notifiersHeader}}
  <align mode= "center">
    <bold>
      <text-line size="0:0">{{notifiersHeader}}</text-line>
    </bold>
    <line-feed />
    <text-line size="0:0">{{dashDivider}}</text-line>
  </align>
  {{/notifiersHeader}}
  {{#notifierOrderItems}}
    {{#header}}
    <align mode="center">
    <line-feed />
    <bold>
      <text-line size="0:0" color="red">{{header}}</text-line>
    </bold>
    </align>
    {{/header}}
    {{#groupedItems}}
      {{#items}}
          <align mode= "center">
            <bold>
              <text-line size="1:0">{{product}}</text-line>
            </bold>
            {{#modifiers}}
            <bold>
            <text-line size="0:0">{{text}}</text-line>
            </bold>
            {{/modifiers}}
          </align>
      {{/items}}
    {{/groupedItems}}
  {{/notifierOrderItems}}
  <align mode= "center">
    {{#customerName}}
      <text-line size= "0:0">{{customerName}}</text-line>
    {{/customerName}}
    {{#customerPhone}}
      <text-line size= "0:0">{{customerPhone}}</text-line>
    {{/customerPhone}}
    {{#customerAddress}}
      <text-line size= "0:0">{{customerAddress}}</text-line>
    {{/customerAddress}}
  </align>
  <paper-cut />
  {{#kitchenBuzzer}}
    <open-cash-drawer></open-cash-drawer>
  {{/kitchenBuzzer}}
</document>
`;

export const lrgKitchenDocketTemplate = `
  <?xml version= "1.0" encoding= "UTF-8"?>
  <document>
    <print-mode mode= {{printMode}} />
    <align mode= "center">
      <text-line size= "0:1">{{title}}</text-line>
      {{#printerProfile}}
      <text-line size= "1:1">{{printerProfile}}</text-line>
      {{/printerProfile}}
      <text-line size= "0:0">{{timeStamp}}</text-line>
    </align>
    <align mode= "center">
      <text-line size= "0:0">{{{divider}}}</text-line>
      <line-feed />
    </align>
    {{#channel}}
      <align mode= "center">
        <text-line size= "0:1">{{channel}}</text-line>
        <text-line size= "0:0">{{{divider}}}</text-line>
        <line-feed />
      </align>
    {{/channel}}
    <align mode= "center">
      <bold>
        <text-line size= "1:1">{{orderType}}</text-line>
      </bold>
    </align>
    {{#orderName}}
      <align mode= "center">
        <text-line size= "0:0">{{{divider}}}</text-line>
        <text-line size= "1:1">{{orderName}}</text-line>
        <text-line size= "0:0">{{{divider}}}</text-line>
      </align>
    {{/orderName}}
    <line-feed />
    <align mode= "center">
      <bold>
        <text-line size= "0:0">{{orderDetails}}</text-line>
      </bold>
    </align>
    <align mode= "center">
      <text-line>{{{divider}}}</text-line>
    </align>
    <align mode= "center">
    <line-feed />
    {{#reasonOrNote}}
      <bold>
        <text-line size= "1:1">{{reasonOrNote}}</text-line>
      </bold>
    <line-feed />
    {{/reasonOrNote}}
    {{#allergens}}
    <bold>
      <text-line>{{{divider}}}</text-line>
      <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{allergens}}</text-line>
    </bold>
    <line-feed />
    {{/allergens}}
    <text-line>{{{divider}}}</text-line>
    </align>
    {{#orderItems}}
      {{#header}}
        <align mode= "center">
          <bold>
           <text-line size="0:1" {{#printHeaderInRed}}color="red"{{/printHeaderInRed}}>{{header}}</text-line>
          </bold>
        {{#showHeaderDivider}}
            <text-line size="0:0">{{dashDivider}}</text-line>
        {{/showHeaderDivider}}
        </align>
      {{/header}}
        {{#groupedItems}}
          {{#subHeader}}
          <line-feed />
            <align mode= "center">
              {{#showSubDivider}}
                  <text-line size="0:0">{{dashDivider}}</text-line>
              {{/showSubDivider}}
              <bold>
                <text-line size="0:1" {{#printSubHeaderInRed}}color="red"{{/printSubHeaderInRed}}>{{subHeader}}</text-line>
              </bold>
            </align>
          {{/subHeader}}
          {{#seatAllergens}}
            <line-feed />
            <bold>
              <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{seatAllergens}}</text-line>
            </bold>
          {{/seatAllergens}}
          {{#items}}
            <line-feed />
            <align mode= "left">
              <bold>
                <text-line size= "1:1">{{product}}</text-line>
              </bold>
            </align>
            {{#itemAllergens}}
            <align mode="left">
              <bold>
                <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line>
              </bold>
            </align>
            {{/itemAllergens}}
            <align mode= "center">
              {{#note}}
                <bold>
                  <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="1:1">{{note}}</text-line>
                </bold>
              {{/note}}
            {{#comboItems}}
              <bold><text-line size="0:1">{{product}}</text-line></bold>
              {{#itemAllergens}}
                <bold><text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line></bold>
              {{/itemAllergens}}
              {{#note}}
                <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="0:1">{{note}}</text-line>
              {{/note}}
              {{#modifiers}}
                <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:0">{{text}}</text-line>
              {{/modifiers}}
            {{/comboItems}}
            {{#modifiers}}
                <text-line {{#printInRed}} color="red" {{/printInRed}} size="1:1" >{{text}}</text-line>
            {{/modifiers}}
          {{/items}}
        {{/groupedItems}}
      {{#showHeaderDivider}}
          <text-line size="0:0">{{dashDivider}}</text-line>
      {{/showHeaderDivider}}
      </align>
    {{/orderItems}}
    {{#notifiersHeader}}
      <align mode= "center">
        <bold>
          <text-line size="1:0">{{notifiersHeader}}</text-line>
        </bold>
        <line-feed />
        <text-line size="0:0">{{dashDivider}}</text-line>
      </align>
    {{/notifiersHeader}}
    {{#notifierOrderItems}}
    {{#header}}
    <align mode="center">
    <bold>
      <text-line size="1:0" color="red">{{header}}</text-line>
    </bold>
    <line-feed />
    </align>
    {{/header}}
      {{#groupedItems}}
        {{#items}}
            <align mode= "center">
              <bold>
                <text-line size="1:0">{{product}}</text-line>
              </bold>
              {{#modifiers}}
              <bold>
              <text-line size="0:0">{{text}}</text-line>
              </bold>
              {{/modifiers}}
            </align>
        {{/items}}
      {{/groupedItems}}
    {{/notifierOrderItems}}
    <align mode= "center">
      {{#customerName}}
        <text-line size= "0:1">{{customerName}}</text-line>
      {{/customerName}}
      {{#customerPhone}}
        <text-line size= "0:1">{{customerPhone}}</text-line>
      {{/customerPhone}}
      {{#customerAddress}}
        <text-line size= "0:1">{{customerAddress}}</text-line>
      {{/customerAddress}}
    </align>
    <paper-cut />
    {{#kitchenBuzzer}}
      <open-cash-drawer></open-cash-drawer>
    {{/kitchenBuzzer}}
  </document>
`;

export const kitchenDocketLabelTemplate = `
<?xml version="1.0" encoding="UTF-8"?>
<document>
  <print-mode mode="{{printMode}}" />
  {{#title}}
  <align mode="center">
    <text-line size="0:0">{{title}}</text-line>
  </align>
  {{/title}}

  {{#divider}}
  <align mode="center">
    <text-line size="0:0">{{{divider}}}</text-line>
  </align>
  {{/divider}}

  {{#orderName}}
  <align mode="center">
    <text-line size="1:1">{{orderName}}</text-line>
  </align>
  {{/orderName}}
  <line-feed />
  {{#orderType}}
  <align mode="center">
    <bold>
      <text-line size="0:0">{{orderType}}</text-line>
    </bold>
  </align>
   {{/orderType}}
  {{#docketAllergens}}
  <align mode="center">
    <bold>
      <text-line color="red">{{docketAllergens}}</text-line>
    </bold>
  </align>
  <line-feed />
  {{/docketAllergens}}

    {{#divider}}
  <align mode="center">
    <text-line size="0:0">{{{divider}}}</text-line>
  </align>
  {{/divider}}

  {{#orderItems}}
  <align mode="center">
    {{#groupedItems}}
    {{#subHeader}}
    <bold>
      <text-line size="0:1" {{#printSubHeaderInRed}}color="red"{{/printSubHeaderInRed}}>{{subHeader}}</text-line>
    </bold>
    {{/subHeader}}
    {{#seatAllergens}}
      <line-feed />
      <bold>
        <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}}>{{seatAllergens}}</text-line>
      </bold>
    {{/seatAllergens}}
    {{#items}}
    <line-feed />
    <bold>
      <text-line size="1:1">{{product}}</text-line>
    </bold>
    {{#itemAllergens}}
    <bold>
      <text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line>
    </bold>
    {{/itemAllergens}}
    {{#note}}
      <bold>
        <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="1:0">{{note}}</text-line>
      </bold>
    {{/note}}
    {{#comboItems}}
      <bold><text-line size="0:1">{{product}}</text-line></bold>
      {{#itemAllergens}}
        <bold><text-line {{#printAllergensInRed}}color="red"{{/printAllergensInRed}} size="0:1">{{itemAllergens}}</text-line></bold>
      {{/itemAllergens}}
      {{#note}}
        <text-line {{#printNoteInRed}}color="red"{{/printNoteInRed}} size="0:1">{{note}}</text-line>
      {{/note}}
      {{#modifiers}}
        <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:0">{{text}}</text-line>
      {{/modifiers}}
    {{/comboItems}}
    {{#modifiers}}
      <text-line {{#printInRed}} color="red" {{/printInRed}} size="0:1">{{text}}</text-line>
    {{/modifiers}}
    {{/items}}
    {{/groupedItems}}
    </align>
  {{/orderItems}}
  <text-line size= "0:0">{{dashDivider}}</text-line>
  {{#notifiersHeader}}
    <align mode= "center">
      <bold>
        <text-line size="0:0">{{notifiersHeader}}</text-line>
      </bold>
      <line-feed />
      <text-line size="0:0">{{dashDivider}}</text-line>
    </align>
  {{/notifiersHeader}}
  {{#notifierOrderItems}}
    {{#header}}
    <align mode="center">
    <bold>
      <text-line size="0:0" color="red">{{header}}</text-line>
    </bold>
    <line-feed />
    </align>
    {{/header}}
    {{#groupedItems}}
      {{#items}}
          <align mode= "center">
            <bold>
              <text-line size="0:0">{{product}}</text-line>
            </bold>
            {{#modifiers}}
            <bold>
            <text-line size="0:0">{{text}}</text-line>
            </bold>
            {{/modifiers}}
          </align>
      {{/items}}
    {{/groupedItems}}
  {{/notifierOrderItems}}

  {{#divider}}
  <align mode="center">
    <text-line size="0:0">{{{divider}}}</text-line>
  </align>
  {{/divider}}

    {{#footer}}
  <align mode="center">
    <text-line size="0:0">{{footer}}</text-line>
    <line-feed />
  </align>
  {{/footer}}
  <paper-cut />
</document>
`;
